var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.98712 12.7885C6.7641 12.7885 4.01172 13.2758 4.01172 15.2274C4.01172 17.179 6.74664 17.6837 9.98712 17.6837C13.2101 17.6837 15.9617 17.1956 15.9617 15.2448C15.9617 13.2941 13.2276 12.7885 9.98712 12.7885Z",
    stroke: "#313131",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.98741 10.0049C12.1025 10.0049 13.8168 8.28984 13.8168 6.17476C13.8168 4.05968 12.1025 2.3454 9.98741 2.3454C7.87233 2.3454 6.15725 4.05968 6.15725 6.17476C6.15011 8.2827 7.85328 9.99778 9.96042 10.0049H9.98741Z",
    stroke: "#313131",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.46e025fc421f95e897d8ca9517883775.svg";
export { ForwardRef as ReactComponent };